import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { ImagePreviewer, FilePreviewer } from 'react-file-utils';

import {
  Container,
  ImagePreview,
  AttachmentPreview,
} from './styles';

const fileType = {
  image: 'image',
};

const AttachmentsPreview = ({
  attachments,
  onRemove,
  onAddAttachments,
  isScheduleMessage,
}) => {
  const attachmentRef = useRef(null);
  const { imageAttachments, fileAttachments } = attachments.reduce(
    (acc, attachment) => {
      if (attachment.file.type?.includes(fileType.image)) {
        acc.imageAttachments.push(attachment);
      } else {
        acc.fileAttachments.push(attachment);
      }

      return acc;
    }, { imageAttachments: [], fileAttachments: [] },
  );

  useEffect(() => {
    if (!attachmentRef.current) return;

    const aTags = attachmentRef.current.querySelectorAll('a');

    aTags.forEach((aTag) => {
      const name = aTag.innerText;
      aTag.setAttribute('download', name);
    });
  }, [fileAttachments]);

  return (
    <Container $isScheduleMessage={isScheduleMessage}>
      {imageAttachments.length > 0 && (
        <ImagePreview>
          <ImagePreviewer
            imageUploads={imageAttachments}
            handleRemove={onRemove}
            handleFiles={onAddAttachments}
            multiple
          />
        </ImagePreview>
      )}
      {fileAttachments.length > 0 && (
        <AttachmentPreview ref={attachmentRef}>
          <FilePreviewer
            uploads={fileAttachments.map((attachment) => ({
              url: attachment.url,
              id: attachment.id,
              file: {
                name: attachment.file.name.replace(/-([a-f0-9-]{8,36})/g, ''),
                type: attachment.file.type,
                size: attachment.file.size,
              },
            }))}
            handleRemove={onRemove}
            handleFiles={onAddAttachments}
          />
        </AttachmentPreview>
      )}
    </Container>
  );
};

AttachmentsPreview.propTypes = {
  attachments: PropTypes.array,
  onRemove: PropTypes.func.isRequired,
  onAddAttachments: PropTypes.func.isRequired,
  isScheduleMessage: PropTypes.bool,
};

AttachmentsPreview.defaultProps = {
  attachments: [],
  isScheduleMessage: false,
};

export default AttachmentsPreview;
